import { handleGetFileStatus, handleParseFile } from '@/api/grt/usual';
import { useEffect, useRef, useState } from 'react';
import { parseStatusDic, fileStatusDic } from '@/utils/Page/constant';
import Toast from '@/components/Toast';
// export const parseStatusMap = {
//     0: '未开始解析',
//     1: '解析成功',
//     2: '解析中',
//     '-1': '已被删除',
//     '-2': '文件不存在'
// };
const UseSendFile = (props = {}) => {
    const timer = useRef();
    const hasParse = useRef(false);
    const { file = {}, changeFileInfo, needParse } = props;

    const [parseResult, setParseResult] = useState({
        status: 2
    });
    const [command, setCommand] = useState([]);
    const [canClickCommand, setCanClickCommand] = useState(false);
    //关闭定时器
    const closeTimer = () => {
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = null;
        }
    };
    //查询文件解析状态
    const getStatus = async () => {
        let res = await handleGetFileStatus({
            file_url: file.file_url,
            object_id: file?.object_id
        });
        if (res && res.success && res?.data) {
            let { status, ...resData } = res?.data;
            setParseResult(res?.data);

            if (res?.data?.status === 1 || res?.data?.status === 3) {
                console.log('清除定时器');
                closeTimer();
            }
        } else {
            closeTimer();
        }
    };
    //定时查询状态
    const queryStatus = () => {
        timer.current = setInterval(() => {
            getStatus();
        }, 3000);
    };
    const startParse = async () => {
        let res = await handleParseFile({
            file_json: file
        });
        if (res && res.success) {
            hasParse.current = true;
            if (res?.data?.status !== 1) {
                queryStatus();
            } else {
                setParseResult({ ...file, status: parseStatusDic.success });
            }
        } else {
            Toast.error(res.msg || '解析失败');
            setParseResult({ ...file, status: parseStatusDic.fail });
        }
    };
    useEffect(() => {
        //文件类型 并且上传成功
        if (needParse && file.status === fileStatusDic.success && !hasParse.current) {
            startParse();
        } else {
            console.log('不需要解析');
        }
    }, [file.status]);
    //处理推荐指令
    const handleCommand = (fileList) => {
        let types = [];
        let successNum = 0;
        fileList.forEach((ele) => {
            if (ele.status === 2 && ele.parse_status === parseStatusDic.success) {
                successNum++;
            }
            if (types.indexOf(ele.type) === -1) {
                types.push(ele.type);
            }
        });
        if (types.length === 1) {
            setCommand(['总结文档']);
        } else {
            setCommand([]);
        }
        if (successNum === fileList.length) {
            setCanClickCommand(true);
        } else {
            setCanClickCommand(false);
        }
    };
    useEffect(() => {
        return () => {
            closeTimer();
        };
    }, []);
    return {
        parseResult,
        handleCommand,
        command,
        canClickCommand
    };
};
export default UseSendFile;
